import styled, { css } from 'styled-components';
import { setButtonStates, ButtonLarge, ButtonMedium, ButtonSmall, ButtonXSmall } from '../styles.js';
import { getColorAlias, getDarkenColor } from '../../../utils/index.js';

const SecondaryButtonStyles = css `
  background-color: ${getColorAlias('interactiveSecondary')};
  color: ${getColorAlias('contentInteractiveSecondary')};
  ${setButtonStates('interactiveSecondary')};

  svg {
    fill: ${getColorAlias('contentInteractiveSecondary')};
  }

  :disabled:hover {
    background-color: ${getColorAlias('disabled01')};
    color: ${getColorAlias('contentDisabled')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${getDarkenColor('active01', 'disabled01')};
      }
    `}
`;
const SecondaryButtonLarge = styled(ButtonLarge) `
  ${SecondaryButtonStyles};
`;
const SecondaryButtonMedium = styled(ButtonMedium) `
  ${SecondaryButtonStyles};
`;
const SecondaryButtonSmall = styled(ButtonSmall) `
  ${SecondaryButtonStyles};
`;
const SecondaryButtonXSmall = styled(ButtonXSmall) `
  ${SecondaryButtonStyles};
`;

export { SecondaryButtonLarge, SecondaryButtonMedium, SecondaryButtonSmall, SecondaryButtonXSmall };
